import { computed, type ComputedRef } from 'vue'
import { useRoute } from 'vue-router'
import {
  COMING_SOON_PRODUCT_PATHS,
  type ProductContextName
} from '../models/ComingSoonProduct'

export function resolveProductContext (path: string): ProductContextName {
  if (path === COMING_SOON_PRODUCT_PATHS.loja || path.startsWith(`${COMING_SOON_PRODUCT_PATHS.loja}/`)) {
    return 'loja'
  }

  if (path === COMING_SOON_PRODUCT_PATHS.pagamentos || path.startsWith(`${COMING_SOON_PRODUCT_PATHS.pagamentos}/`)) {
    return 'pagamentos'
  }

  return 'erp'
}

export function useActiveProductContext (): {
  name: ComputedRef<ProductContextName>
  isComingSoon: ComputedRef<boolean>
  } {
  const route = useRoute()
  const name = computed<ProductContextName>(() => resolveProductContext(route.path))
  const isComingSoon = computed(() => name.value !== 'erp')

  return { name, isComingSoon }
}
